module.exports = __webpack_public_path__ + "static/media/vuetifyjs.eeec0047.svg";